"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconEditText = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var _react = _interopRequireWildcard(require("react"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var IconEditText =
/*#__PURE__*/
function (_Component) {
  _inherits(IconEditText, _Component);

  function IconEditText() {
    _classCallCheck(this, IconEditText);

    return _possibleConstructorReturn(this, _getPrototypeOf(IconEditText).apply(this, arguments));
  }

  _createClass(IconEditText, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("svg", {
        className: "edit-text",
        x: "0px",
        y: "0px",
        width: this.props.width ? this.props.width : "45px",
        viewBox: "0 0 56.769 29.866",
        enableBackground: "new 0 0 56.769 29.866",
        xmlns: "http://www.w3.org/2000/svg"
      }, _react.default.createElement("rect", {
        x: "1.953",
        y: "13.344",
        width: "52",
        height: "3.447"
      }), _react.default.createElement("rect", {
        x: "1.953",
        y: "24.348",
        width: "33.224",
        height: "3.447"
      }), _react.default.createElement("rect", {
        x: "1.953",
        y: "2.475",
        width: "52",
        height: "3.447"
      }));
    }
  }]);

  return IconEditText;
}(_react.Component);

exports.IconEditText = IconEditText;
//# sourceMappingURL=IconEditText.js.map